import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // {
  //   path: '/',
  //   name: 'login',
  //   component: () => import('@/views/login/login.vue')
  // },
  // {
  //   path: '/selectPro',
  //   name: 'selectPro',
  //   component: () => import('@/views/login/selectPro.vue')
  // }
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home/home_public.vue'),
	redirect: '/index',
	children:[{
		path: '/index',
		name: 'index',
		component: () => import('@/views/home/index.vue'),
	},
	{
		path: '/company',
		name: 'company',
		component: () => import('@/views/home/company.vue'),
	},
	{
		path: '/product',
		name: 'product',
		component: () => import('@/views/home/product.vue'),
	},
	{
		path: '/news',
		name: 'news',
		component: () => import('@/views/home/news.vue'),
	},
	{
		path: '/us',
		name: 'us',
		component: () => import('@/views/home/us.vue'),
	}]
  },
  {
	  path: '/news_detail',
	  name: 'news_detail',
	  component: () => import('@/views/home/news_detail.vue'),
	  
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass:'router-link-active'
})

export default router
